import http from '../../utils/Http/Http'
import { getAuth } from 'firebase/auth'

type CreateScheduleRequest = {
	campaign_id: string
	scheduled_times: string[]
	timezone: string
}

type CreateScheduleResponse = {
	schedule_ids: string[]
	message: string
}

export async function createSchedule(
	campaignId: string,
	scheduledTimes: string[],
	timezone: string,
	description: string,
): Promise<CreateScheduleResponse> {
	const response = await http({
		url: `/scheduler/campaign/${campaignId}`,
		method: 'post',
		data: {
			scheduled_times: scheduledTimes,
			timezone: timezone,
			description: description,
		},
	})

	return response.data
}
